import { AnyAction } from 'redux'
import { ISubscriptionState } from '~/shared/store/types'

import {
  SET_SUBSCRIPTION,
  SET_SUBSCRIPTION_ID,
  SET_SUBSCRIPTION_LIST,
} from './actionTypes'

const initState: ISubscriptionState = {
  subscriptionsList: [],
  selectedSubscription: null,
  purchasedSubscriptionId: '',
}

export function subscriptionReducer(
  state: ISubscriptionState = initState,
  { type, payload = null }: AnyAction,
): ISubscriptionState {
  switch (type) {
    case SET_SUBSCRIPTION: {
      return {
        ...state,
        selectedSubscription: payload,
      }
    }
    case SET_SUBSCRIPTION_ID: {
      return {
        ...state,
        purchasedSubscriptionId: payload,
      }
    }
    case SET_SUBSCRIPTION_LIST: {
      return {
        ...state,
        subscriptionsList: payload,
      }
    }
    default:
      return state
  }
}
